type QueryChange = { oldSearch: string; newSearch: string; url: string };

export function onQueryChange(cb: (e: QueryChange) => void) {
	let prev = location.search;

	const notify = () => {
		if (location.search !== prev) {
			const old = prev;
			prev = location.search;
			cb({ oldSearch: old, newSearch: prev, url: location.href });
		}
	};

	// back/forward
	window.addEventListener('popstate', notify);
	// opzionale: se cambi anche il fragment
	window.addEventListener('hashchange', notify);

	// intercetta pushState/replaceState
	const _push = history.pushState;
	history.pushState = function (...args) {
		const ret = _push.apply(this, args as any);
		notify();
		return ret;
	};
	const _replace = history.replaceState;
	history.replaceState = function (...args) {
		const ret = _replace.apply(this, args as any);
		notify();
		return ret;
	};

	// funzione di cleanup (se serve rimuovere i listener)
	return () => {
		window.removeEventListener('popstate', notify);
		window.removeEventListener('hashchange', notify);
		history.pushState = _push;
		history.replaceState = _replace;
	};
}
